<template>
	<div>
		<loader></loader>
		<form class="list-filter flex box" method="get" :action="endPoint" ref="filterForm">
			<div class="one form-group">
				<label for="limit"><i class="fas fa-fw fa-list-ul"></i> Show</label>
				<select id="limit" @change="onFormChange" name="limit" v-model="selectedLimit">
					<option value="null">25</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>
			</div>

			<div class="one form-group">
				<label for="status"><i class="fas fa-fw fa-traffic-light"></i> Status</label>
				<select id="status" @change="onFormChange" name="status" v-model="selectedStatus">
					<option value="null" selected>All</option>
					<option v-for="status in statuses" :value="status">
						{{ status }}
					</option>
				</select>
			</div>

			<div class="two form-group">
				<label for="author"><i class="fas fa-fw fa-user"></i> Author</label>
				<select id="author" @change="onFormChange" name="author" v-model="selectedAuthor">
					<option value="null" selected>All</option>
					<option v-for="author in authors" :value="author.user_id">
						{{ author.full_name }}
					</option>
				</select>
			</div>

			<div class="two form-group">
				<label for="category"><i class="fas fa-fw fa-archive"></i> Category</label>
				<select id="category" @change="onFormChange" name="category" v-model="selectedCategory">
					<option value="null" selected>All</option>
					<option v-for="category in categories" :value="category.id">
						{{ category.title }}
					</option>
				</select>
			</div>

			<div class="two form-group">
				<label for="filterInContent"><i class="fas fa-fw fa-search-location"></i> Search in ...</label>
				<select id="filterInContent" name="filterInContent" v-model="filterInContent">
					<option value="null" selected>Title & URL</option>
					<option value="1">Title, URL & Content</option>
				</select>
			</div>

			<div class="four form-group">
				<label for="search"><i class="fas fa-fw fa-filter"></i> Filter</label>
				<div class="input-group">
					<input id="search" class="input-small" name="search" type="text" placeholder="Search in Title or Slug" v-model="urlParams.search" @change="checkReset" @keyup="onFilterChange">
					<button class="btn btn-primary" :disabled="!this.filterEnabled" @click="clearForm">Filter</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import {eventBus} from "../../app";

	export default {
		props: {
			dataStatuses: {
				type: Array
			},
			dataAuthors: {
				type: Object
			},
			dataCategories: {
				type: Object
			},
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			}
		},
		data() {
			return {
				statuses: this.dataStatuses || [],
				authors: this.dataAuthors || [],
				categories: this.dataCategories || [],
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || {},
				selectedAuthor: this.dataUrlParams.author ? this.dataUrlParams.author : null,
				selectedCategory: this.dataUrlParams.category ? this.dataUrlParams.category : null,
				filterEnabled: this.dataUrlParams.search && this.dataUrlParams.search.length > 0,
				filterInContent: this.dataUrlParams.filterInContent ? this.dataUrlParams.filterInContent : null,
				selectedLimit: this.dataUrlParams.limit ? this.dataUrlParams.limit : null,
				selectedStatus: this.dataUrlParams.status ? this.dataUrlParams.status : null,
			}
		},
		methods: {
			clearForm: function () {
				$('input, select').each(function (_, inp) {
					if ($(inp).val() === '' || $(inp).val() === 'null' || $(inp).val() === null)
						inp.disabled = true;
				});
			},
			checkReset: function () {
				if (this.urlParams.search.length === 0) {
					this.onFormChange();
				}
			},
			onFormChange: function () {
				eventBus.$emit('onLoaderStart');
				this.clearForm();
				this.$refs.filterForm.submit();
			},
			onFilterChange: function () {
				this.filterEnabled = this.urlParams.search && this.urlParams.search.length > 0;
			},
		}
	}
</script>
